<template>
    <div v-for="block in blocks" class="my-4 mx-2 relative flex flex-grow flex-wrap items-center" :class="block.Invalid ? 'border-l-8 border-red-700 pl-8' : null">
        <label :for="block.Id" class="block text-lg text-gray-700 font-semibold w-full">{{ block.Label }}</label>
        <ValidationMessages v-if="block.ValidationMessages" :messages="block.ValidationMessages"></ValidationMessages>
        <textarea :id="block.Id" :rows="block.Rows" class="mt-2 w-full text-gray-800 text-xl placeholder-gray-700 px-2 py-1 border-2 border-gray-400 rounded-lg leading-relaxed flex-grow"></textarea>
    </div>
</template>

<script>
    import { default as ValidationMessages } from "../ValidationMessages.vue";

    export default {
        name: "TextArea",
        components: {
            ValidationMessages
        },
        data() {
            return {
                blocks: [
                    {
                        id: 'TextAreaExample1',
                        Invalid: false,
                        Label: 'What is your favourite ice cream flavour?',
                        Rows: 3
                    },
                    {
                        Id: 'TextAreaExample2',
                        Invalid: true,
                        Label: 'What is your favourite ice cream flavour?',
                        Rows: 3,
                        ValidationMessages: [
                            'The flavour must be more than 4 characters long',
                            'The flavour must not be Vanilla',
                            'The flavour cannot contain a number'
                        ]
                    }
                ]
            }
        }
    };
</script>

<style>
    textarea:focus {
        @apply outline-0;
        box-shadow: 0 0 0 3px rgb(66 153 225 / 50%);
    }
</style>